/**
 * The part of an accumulated transcript past what has already been consumed.
 *
 * The native recognizer grows ONE utterance for as long as a session lasts, re-emitting everything
 * it has heard so far on every interim result. Without slicing off the already-consumed prefix,
 * each interim would re-submit words the drill has already matched — filling blanks the user never
 * spoke again and, worse, re-triggering the "they said something wrong" escalation on every tick.
 *
 * Adapted from the admin editor's `bufferTailPastDispatched`, with one deliberate difference:
 * that version slices on a `"${prefix} "` boundary because English transcripts are space-separated.
 * Mandarin comes back with NO spaces (`我喜欢吃苹果`), so a space-anchored slice would never match
 * and every interim would resubmit the whole utterance. This slices on the raw prefix instead.
 *
 * Falls back to the full transcript when `dispatched` is not actually a prefix — recognizers do
 * sometimes rewrite earlier words as later context arrives, and blanking the buffer on a rewrite
 * would silently drop speech the user has to repeat.
 */
export function transcriptTailPastDispatched(full: string, dispatched: string): string {
  if (dispatched.length === 0) {
    return full;
  }
  if (full === dispatched) {
    return "";
  }
  return full.startsWith(dispatched) ? full.slice(dispatched.length) : full;
}
